import {
	Env
} from './env.js'; //ブラウザなど環境チェック
import {
	PageAncher
} from './page-ancher.js'; //ページ内アンカーリンク（スムーズスクロール）
import {
	Urlparam
} from './urlparam.js';
import {
	ShowForm
} from './showform.js';

import smoothscroll from 'smoothscroll-polyfill';
// https://www.npmjs.com/package/smoothscroll-polyfill
// http://iamdustan.com/smoothscroll/

// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll


export class Main {
	constructor() {
		this.timerResized = false; // resize時
		this.timerScrolled = false; //scroll時
		this._click = '';
		this.env = {};
		this.loadedFlg = false;
		this.body = {};
		this.html = {};
	}

	init() {
		//console.log('init');
		//this.scrCheck = new ScrPos();
		this.body = document.getElementsByTagName('body')[0];
		this.html = document.getElementsByTagName('html')[0];

		// DOMContentLoaded時
		// ------------------------------
		window.addEventListener('DOMContentLoaded', () => {

			// ブラウザOS環境
			this.env = new Env();
			this.env.detectEnv();

			//page ancher
			smoothscroll.polyfill();
			this.pageAncher = new PageAncher();
			this.pageAncher.init();

		});

		// load時
		// ------------------------------
		window.addEventListener('load', () => {


			this.loadedFlg = true;



			//URLパラメータ
			this.paramAncher = new Urlparam();
			this.paramAncher.getParam('lesson', location.href);

			// form切り替え
			this.formManager = new ShowForm();
			this.formManager.changeForm(this.paramAncher.param);



			window.setTimeout(() => {

			}, 600);

			// スクロール時
			window.addEventListener('scroll', () => {

			});

			// ウインドウリサイズ時
			window.addEventListener('resize', () => {

				if (this.timerResized !== false) {
					clearTimeout(this.timerResized);
				}
				this.timerResized = setTimeout(() => {
					//console.log('resize');
				}, 700);
			});


		});
	}
}